<template>
    <div class="record-board-container">
        <Title :strong="2">
            榜单
            <a-button v-if="!competition" class="fold-button" type="link"
                @click="toggleFold()"
            >
                <span v-if="folded"><a-icon type="plus-square" />展开榜单</span>
                <span v-else><a-icon type="minus-square" />折叠榜单</span>
            </a-button>
            <a-button v-if="hasManagePrivilege" class="fold-button" type="link"
                @click="toggleManage()"
            >
                <span v-if="!manageMode"><a-icon type="edit" />管理模式</span>
                <span v-else><a-icon type="bars" />普通模式</span>
            </a-button>
        </Title>
        <div v-if="competition" class="unshow-info">
            <a-alert type="info" show-icon>
                <span slot="description">-- 比赛塔不显示成绩 --</span>
            </a-alert>
        </div>
        <Endings v-show="!folded" v-else-if="flatDifficulty" v-bind="record[0]" />
        <a-collapse v-show="!folded" v-else v-model="activeDifficulty" :bordered="false">
            <a-collapse-panel
                v-for="difficulty of record" :key="difficulty.label"
            >
                <span slot="header" class="header">
                    {{ difficulty.label }}
                </span>
                <Endings v-bind="difficulty" />
            </a-collapse-panel>
        </a-collapse>
    </div>
</template>

<script>
import Title from '@/components/Title.vue'
import Endings from '../components/Endings.vue'
import { default as AAlert } from 'ant-design-vue/es/alert';
import axios from 'axios';
import { createFormData } from '../../../utils/utils';
import { mapState } from 'vuex';
import { checkPrivilege } from '../../admin/privilege';

export default {
    props: {
        record: Array,
        competition: { type: Boolean, default: false }
    },
    data: () => ({
        activeDifficulty: [],
        folded: false,
        manageMode: false,
    }),
    provide() {
        return {
            record: this
        }
    },
    inject: [ 'app' ],
    computed: {
        ...mapState({ userid: 'userid', userPrivilege: 'privilege' }),
        hasManagePrivilege() {
            return checkPrivilege({ submission: 2 }, this.userPrivilege)
                || this.userid === this.app.tower.authorId;
        },
        flatDifficulty() {
            if (this.record.length === 1 && this.record[0].label === '') {
                return true;
            } else {
                return false;
            }
        },
    },
    created() {
        this.activeDifficulty = this.record
            .filter(e => (Number(e.fold) === 0))
            .map(e => e.label);
    },
    methods: {
        toggleFold() {
            this.folded = !this.folded;
        },
        async loadMore(difficulty, ending, count, varifiedOnly) {
            try {
                const { data } = await axios.get("/backend/tower/fetchMoreSubmissions.php", {
                    params: {
                        name: this.app.tower.name, difficulty, ending, count, varifiedOnly,
                    }
                });
                const targetEnding = this.record
                    .find(e => e.label === difficulty)
                    .endings
                    .find(e => e.name === ending);
                console.log(targetEnding);
                targetEnding.submissions = data.submissions
                targetEnding.hasFetchAll = data.hasFetchAll;
            } catch (e) {
                this.$message.error(`拉取失败: ${ e }`);
            }
        },
        toggleManage() {
            if (this.manageMode) {
                this.manageMode = false;
            } else if (this.hasManagePrivilege) {
                this.manageMode = true;
            }
        },
        async deleteSubmission(id) {
            try {
                const { data } = await axios
                    .post("/backend/admin/submission/delete.php", createFormData({
                        id
                    }));
                if (data.code !== 0) {
                    this.$message.error(`删除失败: ${ data }`);
                }
            } catch (e) {
                this.$message.error(`删除失败: ${ e }`);
            }
        }
    },
    components: {
        Title, Endings, AAlert,
    },
}
</script>

<style lang="less" scoped>
.record-board-container {
    text-align: left;
}
.unshow-info {
    margin: 10px;
}
.header {
    font-size: 16px;
}
.fold-button {
    color: rgba(0, 0, 0, 0.45);;
}
</style>
